// extracted by mini-css-extract-plugin
module.exports = {"sbi-images":"Feed_sbi-images__HCiZx"};